'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { Suspense, useState } from 'react';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
import { isAchraMarketingHomePath } from '@/modules/shared/lib/achra-marketing-home-path';
import ff from '@/modules/shared/lib/feature-flags';
import * as NavbarPrimitives from '../primitives';
import { ThemeToggle, ThemeToggleOption } from './theme-toggle';
import { UserButton, UserOption } from './user-button';
function MobileNavbarActions(t0) {
  const $ = _c(8);
  const {
    showThemeToggle
  } = t0;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  let t1;
  if ($[0] !== showThemeToggle) {
    t1 = ff.AUTH_ENABLED && <><UserOption />{showThemeToggle ? <NavbarPrimitives.ActionOptionSeparator /> : null}</>;
    $[0] = showThemeToggle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== showThemeToggle) {
    t2 = showThemeToggle ? <ThemeToggleOption /> : null;
    $[2] = showThemeToggle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== mobileMenuOpen || $[5] !== t1 || $[6] !== t2) {
    t3 = <NavbarPrimitives.ActionWithOptions className="flex md:hidden" open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>{t1}{t2}</NavbarPrimitives.ActionWithOptions>;
    $[4] = mobileMenuOpen;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function DesktopNavbarActions(t0) {
  const $ = _c(8);
  const {
    showThemeToggle
  } = t0;
  const [desktopUserMenuOpen, setDesktopUserMenuOpen] = useState(false);
  let t1;
  if ($[0] !== showThemeToggle) {
    t1 = showThemeToggle ? <ThemeToggle /> : null;
    $[0] = showThemeToggle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== desktopUserMenuOpen || $[3] !== showThemeToggle) {
    t2 = ff.AUTH_ENABLED && <>{showThemeToggle ? <NavbarPrimitives.ActionSeparator /> : null}<UserButton open={desktopUserMenuOpen} onOpenChange={setDesktopUserMenuOpen} /></>;
    $[2] = desktopUserMenuOpen;
    $[3] = showThemeToggle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <NavbarPrimitives.ActionsGroup className="hidden md:flex">{t1}{t2}</NavbarPrimitives.ActionsGroup>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function NavbarActionsContent(t0) {
  const $ = _c(12);
  const {
    showThemeToggle
  } = t0;
  const showMobileMenu = ff.AUTH_ENABLED || showThemeToggle;
  const showDesktopActions = ff.AUTH_ENABLED || showThemeToggle;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      from: "md"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isDesktop = useMediaQuery(t1);
  let t2;
  if ($[1] !== isDesktop || $[2] !== showMobileMenu || $[3] !== showThemeToggle) {
    t2 = showMobileMenu ? <MobileNavbarActions key={isDesktop ? "mobile-hidden" : "mobile-visible"} showThemeToggle={showThemeToggle} /> : null;
    $[1] = isDesktop;
    $[2] = showMobileMenu;
    $[3] = showThemeToggle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isDesktop || $[6] !== showDesktopActions || $[7] !== showThemeToggle) {
    t3 = showDesktopActions ? <DesktopNavbarActions key={isDesktop ? "desktop-visible" : "desktop-hidden"} showThemeToggle={showThemeToggle} /> : null;
    $[5] = isDesktop;
    $[6] = showDesktopActions;
    $[7] = showThemeToggle;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <NavbarPrimitives.ActionsArea>{t2}{t3}</NavbarPrimitives.ActionsArea>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function NavbarActionsWithPathname() {
  const $ = _c(4);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = isAchraMarketingHomePath(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const showThemeToggle = !t0;
  let t1;
  if ($[2] !== showThemeToggle) {
    t1 = <NavbarActionsContent showThemeToggle={showThemeToggle} />;
    $[2] = showThemeToggle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}

/**
 * Shared navbar actions (theme toggle and user button).
 * Pathname is wrapped in Suspense for Cache Components / static prerender compatibility.
 */
function NavbarActions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={<NavbarActionsContent showThemeToggle={true} />}><NavbarActionsWithPathname /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
NavbarActions.displayName = 'NavbarActions';
export { NavbarActions };